





























import { SubjectBlock } from '@/views/Subjects.vue';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class SubjectComponent extends Vue {
  @Prop({ required: true })
  subject!: SubjectBlock;
}
